import { render, staticRenderFns } from "./TheTransferCall.vue?vue&type=template&id=731553be&scoped=true"
import script from "./TheTransferCall.vue?vue&type=script&lang=js"
export * from "./TheTransferCall.vue?vue&type=script&lang=js"
import style0 from "./TheTransferCall.vue?vue&type=style&index=0&id=731553be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731553be",
  null
  
)

export default component.exports